import React, { FC, ReactNode, useId } from 'react';

import { Box, ButtonBase, Collapse, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormikProps, FormikValues } from 'formik';

import useCollapsibleFormSection from '../../../hooks/useCollapsibleFormSection';

import classes from './style';

interface ICollapsibleFormSection {
  title: string;
  formik: FormikProps<FormikValues>;
  fieldNames: string[];
  children: ReactNode;
}

const CollapsibleFormSection: FC<ICollapsibleFormSection> = ({
  title,
  formik,
  fieldNames,
  children,
}) => {
  const contentId = useId();
  const { errors, submitCount } = formik;

  const { isExpanded, handleToggle } = useCollapsibleFormSection({
    fieldNames,
    errors,
    submitCount,
  });

  return (
    <Box sx={classes.root}>
      <ButtonBase
        sx={classes.header}
        onClick={handleToggle}
        aria-expanded={isExpanded}
        aria-controls={contentId}
      >
        {title}
        <Box component="span" sx={classes.titleLine} />
        <ExpandMoreIcon sx={[classes.icon, isExpanded && classes.iconExpanded]} />
      </ButtonBase>
      <Collapse id={contentId} in={isExpanded} timeout="auto">
        <Grid container>{children}</Grid>
      </Collapse>
    </Box>
  );
};

export default CollapsibleFormSection;
